// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpCheckSquareIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpCheckSquareIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpCheckSquareIconOutlined = function DrrpCheckSquareIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpCheckSquareIconOutlinedSvg
  }));
};

DrrpCheckSquareIconOutlined.displayName = 'DrrpCheckSquareIconOutlined';
export default React.forwardRef(DrrpCheckSquareIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpCheckSquareIconOutlined.js
// module id = 2493
// module chunks = 0